import {
  Box,
  Card,
  CardContent,
  List,
  ListItem,
  Typography,
} from '@mui/material'
import React from 'react'
import { Link } from 'react-router-dom'

const workflowSteps = [
  {
    id: 'opaquer',
    label: 'Opaquer',
    route: 'opaquer',
    description: 'Get opaquer recipes.',
    step: 1,
  },
  {
    id: 'opaquer-staining',
    label: 'Opaquer Staining',
    route: 'opaquer-staining',
    description: 'Get staining recipes to correct the opaquer chroma.',
    step: 2,
  },
  {
    id: 'dentin',
    label: 'Dentin',
    route: 'dentin',
    description: 'Get ceramic recipes for the dentin layer.',
    step: 3,
  },
  {
    id: 'internal-effects',
    label: 'Internal Effects',
    route: 'internal-effects',
    description: 'Get ceramic recipes for internal details.',
    step: 4,
  },
  {
    id: 'staining-corrections',
    label: 'Staining Corrections',
    route: 'staining-corrections',
    description: 'Get internal staining recipes for final color corrections.',
    step: 5,
  },
  {
    id: 'enamel',
    label: 'Enamel',
    route: 'enamel',
    description: 'Get enamel advice to finish the PFM crown.',
    step: 6,
  },
]

const PfmCrownIndex = () => {
  return (
    <Box sx={{ p: 3, maxWidth: '800px', margin: '0 auto' }}>
      <Typography variant="h4" component="h1" gutterBottom>
        PFM Crown Workflow
      </Typography>
      <Typography variant="body1" paragraph>
        Follow these steps to create your PFM (Porcelain-Fused-to-Metal) crown.
        Each step provides specific recipes and guidance for achieving optimal
        results.
      </Typography>

      <List sx={{ mt: 2 }}>
        {workflowSteps.map((step) => (
          <ListItem key={step.id} sx={{ mb: 2, p: 0 }}>
            <Card sx={{ width: '100%' }}>
              <CardContent>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                  <Typography variant="h6" component="div" sx={{ mr: 2 }}>
                    Step {step.step}:
                  </Typography>
                  <Typography variant="h6" component="div">
                    {step.label}
                  </Typography>
                </Box>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ mb: 2 }}
                >
                  {step.description}
                </Typography>
                <Link
                  to={step.route}
                  style={{
                    textDecoration: 'none',
                    color: 'inherit',
                  }}
                >
                  <Box
                    sx={{
                      bgcolor: 'primary.main',
                      color: 'primary.contrastText',
                      py: 1,
                      px: 2,
                      borderRadius: 1,
                      display: 'inline-block',
                      '&:hover': {
                        bgcolor: 'primary.dark',
                      },
                    }}
                  >
                    Go to {step.label}
                  </Box>
                </Link>
              </CardContent>
            </Card>
          </ListItem>
        ))}
      </List>
    </Box>
  )
}

export default PfmCrownIndex
